import type { Analytics } from '@segment/analytics-next'

/**
 * Hook to access the Segment analytics instance.
 *
 * Segment is initialized in instrumentation-client.ts and attached to window.analytics.
 * This hook provides typed access to that instance.
 *
 * @returns The Segment Analytics instance if available, undefined otherwise
 */
export function useAnalytics(): Analytics | undefined {
  if (typeof window === 'undefined') return undefined

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (window as any).analytics as Analytics | undefined
}
